import React from 'react'
import PropTypes from 'prop-types'
import {connect} from "react-redux"

NavbarTopDesktop.propTypes = {
    onClick: PropTypes.func.isRequired,
    isCollapsed: PropTypes.bool.isRequired
}

function NavbarTopDesktop() {
    const toggleMenuMobile = () => {
        const body = document.getElementsByTagName("body")[0];
        if (body.getAttribute('data-menu-mobile') === 'openMenuMobile') {
            body.removeAttribute('data-menu-mobile')
        } else {
            body.setAttribute('data-menu-mobile', 'openMenuMobile')
        }
    }

    return (
        <div className="NavTopDesktop">
            <nav className="NavbarTop">
                <ul className="NavLeft">
                    <li className="iconToggleMenu">
                        <span onClick={toggleMenuMobile} className="material-icons cursor-pointer ml-3">menu</span>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        status: state.rolesReducer.status,
        phoneNumber: state.rolesReducer.phoneNumber
    };
};

export default connect(mapStateToProps)(NavbarTopDesktop)
